'use client';

import { PATHS } from '@bb/lib/constants';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';

export function ClientPrivatePage({ children }: { children: ReactNode }) {
  const { userProfile, userProfileLoading } = useUserProfile();
  const { push } = useRouter();
  if (!userProfile && !userProfileLoading) {
    return push(PATHS.Login);
  }

  return <>{children}</>;
}
